import { render, staticRenderFns } from "./JsonDiff.vue?vue&type=template&id=2792a075&"
import script from "./JsonDiff.vue?vue&type=script&lang=js&"
export * from "./JsonDiff.vue?vue&type=script&lang=js&"
import style0 from "./JsonDiff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports